/*
 * @Author: wenrongyun wenrongyun@benlaixian.onaliyun.com
 * @Date: 2022-05-17 16:51:12
 * @LastEditors: wenrongyun wenrongyun@benlaixian.onaliyun.com
 * @LastEditTime: 2022-05-20 21:05:48
 * @FilePath: /lowcode-materials/src/components/pro-form/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { createElement, cloneElement, Component, createRef } from "react";
import { } from 'antd'
import { Form, Button, ResponsiveGrid, Box, Grid } from '@alifd/next';
import type { FormProps } from '@alifd/next/types/form';
import { ProForm } from "@ant-design/pro-form";
import type { ResponsiveGridProps } from '@alifd/next/types/responsive-grid';

import './index.less'

class BLProForm extends Component<any, any> {

  formChange = (e: any) => {
    console.log('表单数据000', e)
    this.props.setState(this.props.formKey, e)
  }

  submitData = (type: any) => {
    console.log('点击按钮类型', type)
    if (type === 'submint') {
      console.log('提交数据按钮数据', this.props.getState(this.props.formKey))
    } else {

    }

  }



  getRows() {
    let { children, columns } = this.props;
    var childrenLength = children.length;
    var rows = [];
    for (var index = 0; index < childrenLength;) {
      var subRows = [];
      while (index < childrenLength) {
        subRows.push(children[index++]);
        if (index % columns == 0) {
          break;
        }
      }
      rows.push(subRows);
    }
    return rows;
  }


  render() {
    const { ...otherProps } = this.props
    console.log('formProps', this.props, otherProps)
    let rowArr = this.getRows()
    return <Box padding={20}>
      <Form
        labelCol={{ style: { width: 120 } }}
        {...this.props}
        onChange={this.formChange}>
        {
          rowArr.map((item: any, index: number) => {
            return (
              <Grid.Row key={index} justify='space-around' className='formRow'>
                {formatFormItems(item, { ...otherProps })}
                {
                  holdFormItems(this, index, rowArr.length - 1, rowArr[index])
                }
              </Grid.Row>
            );
          })
        }
        {this.props.btn_newline && <div style={{
          display: 'flex',
          justifyContent: this.props.btn_justify,
          alignItems: 'center'
        }}>
          {
            this.props.formbtns?.map((item: any, index: number) => {
              return (
                <Button key={index} onClick={() => {
                  this.submitData(item?.btntype)
                }}
                  style={{
                    marginRight: 10 + 'px'
                  }}>
                  {item?.btnname || '其他'}
                </Button>
              )
            })
          }
        </div>}
      </Form>
    </Box>;
  }
}


export default BLProForm;


export const formatFormItems = (children: any, props: any = {}) => {
  const { status, labelAlign, labelCol, wrapperCol, labelTextAlign } = props;
  const _children = children.filter(
    (child: any) => child && ['function', 'object'].indexOf(typeof child) > -1,
  );

  return React.Children.map(_children, (child) => {
    console.log('formDataChild', child)
    if (child && ['function', 'object'].indexOf(typeof child) > -1) {
      const childrenProps = {
        labelCol: child.props?.labelCol ?? labelCol,
        labelAlign: child.props?.labelAlign ?? labelAlign,
        wrapperCol: child.props?.wrapperCol ?? wrapperCol,
        labelTextAlign: child.props?.labelTextAlign ?? labelTextAlign,
        status,
      };
      const { formItemProps = {} } = child.props;
      const formItemColumn = formItemProps.columnSpan;
      const columnSpan = formItemColumn ?? 1;

      return createElement(
        Grid.Col,
        { span: 6 },
        cloneElement(child, {
          formItemProps: Object.assign({}, pickDefined(childrenProps), formItemProps),
        }),
      );
    }

    return child;
  });
};

export const holdFormItems = (_this: any, index: number, lastIndex: number, lastValue: any) => {
  let { columns, btn_justify_line } = _this.props;
  let isLast = index !== 0 && index === lastIndex
  if (isLast && lastValue.length < columns) {
    let arr = new Array(columns - lastValue.length).fill([])
    let len = arr.length
    return arr.map((item, index) => {
      return (
        <Grid.Col span={6}>
          {
            holdFormItemsBtn(_this, btn_justify_line, index, len - 1)
          }
        </Grid.Col>
      )
    })

  } else {
    return null
  }
}

export const holdFormItemsBtn = (_this: any, justify: string, index: number, len: number) => {
  let { btn_newline, labelAlign } = _this.props;
  if (!btn_newline && (justify === 'flex-start' && index === 0) || (justify === 'flex-end' && index === len)) {
    return (
      <div style={{
        height: '100%',
        display: 'flex',
        justifyContent: _this.props.btn_justify_line,
        alignItems: "flex-start"
      }}>
        {
          _this.props.formbtns?.map((item: any, index: number) => {
            return (
              <div>
                {labelAlign === 'top' && <div className="next-form-item-label" style={{ height: 28 + 'px' }}></div>}
                <div className="next-form-item-control">
                  <Button key={index} onClick={() => {
                    _this.submitData(item?.btntype)
                  }}
                    style={{
                      marginRight: 10 + 'px'
                    }}>
                    {item?.btnname || '其他'}
                  </Button>
                </div>

              </div>

            )
          })
        }
      </div>
    )
  } else {
    return null
  }



}


interface ObjKeyType {
  [key: string]: any
}

const pickDefined = (obj: ObjKeyType = {}) => {
  const newObj: ObjKeyType = {};
  Object.keys(obj).forEach((i: any) => {
    if (typeof obj[i] !== 'undefined') {
      newObj[i] = obj[i];
    }
  });
  return newObj;
};

